import type { SupportedLanguage } from '../../i18n/routes'

const inventoryMessages = {
  valueYes: {"it": "Sì", "en": "Yes"},
  valueNo: {"it": "No", "en": "No"},
  extraDetailsTitle: {"it": "Altre informazioni", "en": "Additional information"},
  equipmentComfort: {"it": "Comfort e interni", "en": "Comfort and interior"},
  equipmentSafety: {"it": "Sicurezza e assistenza", "en": "Safety and assistance"},
  equipmentTechnology: {"it": "Tecnologia e connettività", "en": "Technology and connectivity"},
  equipmentExterior: {"it": "Esterni e luci", "en": "Exterior and lighting"},
  equipmentOther: {"it": "Pacchetti e altre dotazioni", "en": "Packages and other equipment"},
  equipmentIntro: {"it": "Dotazioni principali riportate nella scheda originale. Verifica con noi l’equipaggiamento del veicolo.", "en": "Main equipment listed in the original record. Confirm the vehicle’s equipment with us."},
  optionalEquipment: {"it": "Optional", "en": "Optional"},
  descriptionTitle: {"it": "Descrizione", "en": "Description"},
  financeTitle: {"it": "Proposta di finanziamento", "en": "Finance proposal"},
  financeDeposit: {"it": "Anticipo", "en": "Deposit"},
  financeDuration: {"it": "Durata (mesi)", "en": "Term (months)"},
  financeAmount: {"it": "Importo finanziato", "en": "Amount financed"},
  financeFinalPayment: {"it": "Rata finale", "en": "Final payment"},
  financeFees: {"it": "Spese", "en": "Fees"},
  financeTotal: {"it": "Totale dovuto", "en": "Total payable"},
  tanPercent: {"it": "TAN", "en": "Nominal interest rate"},
  taegPercent: {"it": "TAEG", "en": "APR"},
  documentsTitle: {"it": "Documenti e video", "en": "Documents and video"},
  videoAction: {"it": "Guarda il video del veicolo", "en": "Watch the vehicle video"},
  energyPetrol: {"it": "Benzina", "en": "Petrol"},
  energyHybrid: {"it": "Ibrida", "en": "Hybrid"},
  energyPlugInHybrid: {"it": "Ibrida plug-in", "en": "Plug-in hybrid"},
  energyElectric: {"it": "Elettrica", "en": "Electric"},
  energyLpg: {"it": "GPL", "en": "LPG"},
  energyCng: {"it": "Metano", "en": "CNG"},
  snapshotNote: {"it": "Dati della scheda originale rilevati il {{date}}. Prezzo e disponibilità da confermare.", "en": "Original listing details recorded on {{date}}. Confirm price and availability."},
  priceOnRequest: {"it": "Prezzo su richiesta", "en": "Price on request"},
  rentalOffer: {"it": "Disponibile per noleggio", "en": "Rental enquiry"},
  saleOffer: {"it": "Prezzo del veicolo", "en": "Vehicle price"},
  availabilityAvailable: {"it": "Disponibile", "en": "Available"},
  availabilityReserved: {"it": "Riservata", "en": "Reserved"},
  availabilitySold: {"it": "Venduta", "en": "Sold"},
  accessoriesEmpty: {
    it: 'Contattaci per conoscere gli accessori inclusi in questo veicolo.',
    en: 'Contact us to confirm the accessories included with this vehicle.',
  },
  accessoriesTitle: { it: 'Accessori', en: 'Accessories' },
  allEnergies: { it: 'Tutte le alimentazioni', en: 'All powertrains' },
  allMakes: { it: 'Tutte le marche', en: 'All makes' },
  allTransmissions: { it: 'Tutti i cambi', en: 'All transmissions' },
  backToInventory: { it: 'Torna al catalogo', en: 'Back to the catalogue' },
  cardOpen: { it: 'Apri la scheda di {{vehicle}}', en: 'Open the details for {{vehicle}}' },
  catalogDescription: {
    it: 'Esplora i veicoli TS Auto e trova quello più adatto alle tue esigenze.',
    en: 'Explore TS Auto vehicles and find the one that best fits your needs.',
  },
  catalogEyebrow: { it: 'Veicoli disponibili', en: 'Available vehicles' },
  catalogIntro: {
    it: 'Trova la tua prossima auto tra i veicoli disponibili.',
    en: 'Find your next car among our available vehicles.',
  },
  catalogMetadataTitle: { it: 'Veicoli — TS Auto', en: 'Vehicles — TS Auto' },
  catalogTitle: { it: 'Il nostro parco auto.', en: 'Our cars.' },
  contactAction: { it: 'Chiedi disponibilità per questa auto', en: 'Check availability for this vehicle' },
  contactActionLabel: {
    it: 'Chiedi disponibilità per {{vehicle}}, riferimento {{reference}}',
    en: 'Check availability for {{vehicle}}, reference {{reference}}',
  },
  dataIncomplete: {
    it: 'Contattaci per ricevere tutti i dettagli e le condizioni del veicolo.',
    en: 'Contact us for full vehicle details and terms.',
  },
  detailDescription: {
    it: 'Fotografie, caratteristiche e informazioni su {{vehicle}}.',
    en: 'Photos, specifications and information about {{vehicle}}.',
  },
  detailEyebrow: { it: 'Scheda veicolo', en: 'Vehicle record' },
  detailLoadingDescription: {
    it: 'Scheda veicolo TS Auto.',
    en: 'TS Auto vehicle details.',
  },
  detailLoadingTitle: { it: 'Scheda veicolo — TS Auto', en: 'Vehicle record — TS Auto' },
  detailTitle: { it: '{{vehicle}} — TS Auto', en: '{{vehicle}} — TS Auto' },
  detailUnavailable: {
    it: 'Questa scheda non è disponibile. Torna al catalogo per vedere gli altri veicoli.',
    en: 'This vehicle is unavailable. Return to the catalogue to view other vehicles.',
  },
  emptyAction: { it: 'Azzera i filtri', en: 'Reset filters' },
  emptyBody: {
    it: 'Nessun veicolo combina questi criteri. Azzera i filtri o prova una selezione diversa.',
    en: 'No vehicle combines these criteria. Reset the filters or try a different selection.',
  },
  emptyTitle: { it: 'Nessun risultato', en: 'No results' },
  energyDiesel: { it: 'Diesel', en: 'Diesel' },
  energyDieselMildHybrid: { it: 'Diesel mild hybrid', en: 'Diesel mild hybrid' },
  energyPetrolMildHybrid: { it: 'Benzina mild hybrid', en: 'Petrol mild hybrid' },
  errorBody: {
    it: 'Non è stato possibile caricare i veicoli. Riprova senza perdere i filtri selezionati.',
    en: 'The vehicles could not be loaded. Try again without losing your selected filters.',
  },
  errorTitle: { it: 'Caricamento interrotto', en: 'Loading interrupted' },
  factsEnergy: { it: 'Alimentazione', en: 'Powertrain' },
  factsMileage: { it: 'Chilometraggio', en: 'Mileage' },
  factsMonthlyPayment: { it: 'Rata mensile', en: 'Monthly payment' },
  factsPrice: { it: 'Prezzo', en: 'Price' },
  factsTransmission: { it: 'Cambio', en: 'Transmission' },
  factsYear: { it: 'Anno', en: 'Year' },
  filterActive_one: { it: '{{count}} filtro attivo', en: '{{count}} active filter' },
  filterActive_other: { it: '{{count}} filtri attivi', en: '{{count}} active filters' },
  filterApply: { it: 'Mostra i risultati', en: 'Show results' },
  filterClose: { it: 'Chiudi i filtri', en: 'Close filters' },
  filterDescription: {
    it: 'Affina la ricerca usando le caratteristiche disponibili.',
    en: 'Refine your search using the available specifications.',
  },
  filterEnergy: { it: 'Alimentazione', en: 'Powertrain' },
  filterMake: { it: 'Marca', en: 'Make' },
  filterOpen: { it: 'Apri i filtri', en: 'Open filters' },
  filterReset: { it: 'Azzera', en: 'Reset' },
  filterTitle: { it: 'Filtri veicoli', en: 'Vehicle filters' },
  filterTransmission: { it: 'Cambio', en: 'Transmission' },
  galleryCurrent: { it: 'Foto {{current}} di {{count}}', en: 'Photo {{current}} of {{count}}' },
  galleryLabel: { it: 'Galleria fotografica di {{vehicle}}', en: 'Photo gallery for {{vehicle}}' },
  galleryNext: { it: 'Foto successiva', en: 'Next photo' },
  galleryPrevious: { it: 'Foto precedente', en: 'Previous photo' },
  gallerySelect: { it: 'Mostra la foto {{current}} di {{count}}', en: 'Show photo {{current}} of {{count}}' },
  guaranteeBody: {
    it: 'Garanzia e condizioni dipendono dal veicolo e dal contratto. Chiedi una verifica citando il riferimento {{reference}}.',
    en: 'Warranty and terms depend on the vehicle and contract. Ask for confirmation using reference {{reference}}.',
  },
  guaranteeMark: { it: 'Garanzia da verificare sul veicolo', en: 'Warranty to verify for this vehicle' },
  guaranteeTitle: { it: 'Garanzia contestuale', en: 'Vehicle-specific warranty' },
  imageDetail: { it: '{{vehicle}}, dettaglio', en: '{{vehicle}}, detail' },
  imageFront: { it: '{{vehicle}}, vista anteriore', en: '{{vehicle}}, front view' },
  imageFrontThreeQuarter: {
    it: '{{vehicle}}, vista anteriore laterale',
    en: '{{vehicle}}, front three-quarter view',
  },
  imageRear: { it: '{{vehicle}}, vista posteriore', en: '{{vehicle}}, rear view' },
  imageRearThreeQuarter: {
    it: '{{vehicle}}, vista posteriore laterale',
    en: '{{vehicle}}, rear three-quarter view',
  },
  imageUnavailable: { it: 'Immagine del veicolo non disponibile', en: 'Vehicle image unavailable' },
  loading: { it: 'Caricamento veicoli.', en: 'Loading vehicles.' },
  reference: { it: 'Riferimento {{reference}}', en: 'Reference {{reference}}' },
  resultCount_one: { it: '{{count}} veicolo', en: '{{count}} vehicle' },
  resultCount_other: { it: '{{count}} veicoli', en: '{{count}} vehicles' },
  retry: { it: 'Riprova', en: 'Try again' },
  sortLabel: { it: 'Ordina per', en: 'Sort by' },
  sortMakeAsc: { it: 'Marca dalla A alla Z', en: 'Make A to Z' },
  sortMakeDesc: { it: 'Marca dalla Z alla A', en: 'Make Z to A' },
  sortSource: { it: 'Ordine predefinito', en: 'Default order' },
  technicalDataTitle: { it: 'In sintesi', en: 'At a glance' },
  transmissionAutomatic: { it: 'Automatico', en: 'Automatic' },
  transmissionManual: { it: 'Manuale', en: 'Manual' },
} as const satisfies Record<string, Record<SupportedLanguage, string>>

export type InventoryMessageKey = keyof typeof inventoryMessages

export function translateInventory(
  language: SupportedLanguage,
  key: InventoryMessageKey,
  values: Record<string, string | number> = {},
) {
  return Object.entries(values).reduce(
    (message, [name, value]) => message.replaceAll(`{{${name}}}`, String(value)),
    inventoryMessages[key][language] as string,
  )
}
